export const categories = [
    { id: 1, name: "pizza" },
    { id: 2, name: "burgery" },
    { id: 4, name: "sałatki" },
    { id: 5, name: "dodatki" },
  ];